var React = require('react');

function DnsRebindTest (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"#E8EFFF","strokeWidth":"2","d":"M21 32c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11Z","key":0}),React.createElement("path",{"stroke":"#E8EFFF","strokeLinecap":"round","strokeWidth":"2","d":"m29 29 9.5 9.5","key":1}),React.createElement("path",{"fill":"#E8EFFF","d":"M21 15.584a5 5 0 0 1 5 5l-.008.277a4.693 4.693 0 0 1-1.887 3.49l-.416.31v1.103a.78.78 0 0 1-1.198.66.782.782 0 0 0-.807-.016l-.186.108a.937.937 0 0 1-.98-.028l-.047-.03a.844.844 0 0 0-.888-.021.846.846 0 0 1-1.272-.73V24.66l-.45-.34A4.68 4.68 0 0 1 16 20.584a5 5 0 0 1 5-5Zm-3.403 5.525a1.492 1.492 0 1 0 2.983 0v-.02h-2.982l-.001.02Zm3.782-.02-.001.02a1.493 1.493 0 0 0 2.983 0v-.02h-2.982Z","key":2})]);
}

DnsRebindTest.defaultProps = {"width":"48","height":"48","fill":"none","viewBox":"0 0 48 48"};

module.exports = DnsRebindTest;

DnsRebindTest.default = DnsRebindTest;
